import whirlpoolSprite from './whirlpool.svg?url';
import amanaSprite from './amana.svg?url';
import maytagSprite from './maytag.svg?url';
import kitchenAidSprite from './kitchenaid.svg?url';

const spriteRegistry: Record<string, string> = {
  Whirlpool: whirlpoolSprite,
  Maytag: maytagSprite,
  KitchenAid: kitchenAidSprite,
  Amana: amanaSprite,
};

export const getSpriteUrl = (brand: string): string => {
  return spriteRegistry[brand] ?? whirlpoolSprite;
};
